import React from 'react';
import { Link, Routes, Route, Navigate } from 'react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSection, Card } from '@patternfly/react-core';
import ContentError from 'components/ContentError';
import UIDetail from './UIDetail';
import UIEdit from './UIEdit';

function UI() {
  const { t } = useLingui();
  const baseURL = '/settings/ui';
  return (
    <PageSection hasBodyWrapper={false}>
      <Card>
        <Routes>
          <Route
            index
            element={<Navigate to={`${baseURL}/details`} replace />}
          />
          <Route path="details" element={<UIDetail />} />
          <Route path="edit" element={<UIEdit />} />
          <Route
            path="*"
            element={
              <ContentError isNotFound>
                <Link
                  to={`${baseURL}/details`}
                >{t`View User Interface settings`}</Link>
              </ContentError>
            }
          />
        </Routes>
      </Card>
    </PageSection>
  );
}

export default UI;
